
export interface FormDropdown {
    key?: any;
    value?: string;
    criteria?: string;
    isChecked?: boolean;
    hide?: boolean;
    disable?: boolean;
    sponsorName?: string;
    lable?: string;
    dropDownField?: boolean;
    showAll?: boolean;
    fieldType?: string;
    sortId?: string;
    loadId?: boolean;
    data?: any;
}

export interface NotificationRuleRequestData {
    ruleName: string;
    ruleTypeId: number;
    protocolFk: number;
    criteria: string;
    effectiveStartDate: string;
    effectiveEndDate: string;
    emailFlag: boolean;
    emailImmediateFlag: boolean;
}

export interface FormDropDownData {
    protocolCode: string;
    sponsorName: string;
    specimenType: string;
    region: string;
    countryCode?: string;
    countryName?: string;
    protocolVisitCode?: string;
    visitDescription?: string;
    expectedReceiptCondition?: string;
    investigatorNumber?: string;
    investigatorName?: string;
    batchReturn?: string;
}

export interface ExcludeFilterItems {
    protocol?: boolean;
    region?: boolean;
    specimenTypes?: boolean;
}

export interface SampleMonitorEditRuleRequest {
    ruleId: number;
    monitorRuleName: string;
    monitorCritera: string;
    effectiveStartDate: string;
    effectiveEndDate: string;
    emailFlag: boolean;
    emailImmediateFlag: boolean;
}

export interface NotificationRuleType {
    ruleTypeId: number;
    ruleTypeName: string;
}

export interface NotificationData {
    accessionNumber?: string;
    containerNumber?: string;
    protocolCode?: string;
    region?: string;
    projectNumber?: string;
    siteNumber?: string;
    screeningNumber?: string;
    patientNumber?: string;
    currentSampleStatus?: string;
    ruleEvent?: string;
    notificationDate?: any;
    edit?: string;
    accessionContainer?: string;
    isNew?: boolean;
    isDirectChild?: boolean;
    ruleId?: number;
    ruleName: string;
}

export interface RuleData {
    ruleName: string;
    protocol: string;
    specimenType: string;
    event: string;
    frequency: string;
    expirationDate: string;
    createdDate: string;
    lastEditedDate: string;
    numberOfDays: string;
}

export interface NotificationStatus {
    deletedFlag: string;
    ruleId: number;
}

export interface NotificationCondition {
    selectedCondition?: FormDropdown;
    selectedConditionValue?: FormDropdown[];
    conditionList?: FormDropdown[];
    conditionValueList?: FormDropdown[];
    isAutoSelected?: boolean;
}

export enum ConditionTypes {
    region = 'Region',
    country = 'Country',
    visitDescription = 'Visit Description',
    visitCode = 'Protocol Visit Code',
    investigator = 'Investigator',
    batchReturn = 'Include batch return samples?',
    numberOfDays = 'Number of days past requisition received date',
    expectedReceiptCondition = 'Expected Receipt Condition'
}

export enum RuleEventType {
    CancelledEvent = 1,
    ActiveeQueryEvent = 2,
    PendingArrivalNonBatch = 3,
    PendingArrivalBatch = 4,
}

export enum EventType {
    cancelledSamples = 'Cancelled Sample',
    activeEquery = 'Hold (Active eQuery)',
    PendingArrivalNonBatch = 'Samples Pending Arrival Non-Batch',
    PendingArrivalBatch = 'Samples Pending Arrival Batch'
}

export interface MonitorCriteriaJSON {
    protocol: { protocolCode: string, sponsorName: string, key: string };
    specimenTypes: [];
    regions: [];
    countries: [];
    visitDescriptions: [];
    protocolVisitCodes: [];
    investigators: [];
    expectedReceiptConditions: [];
    numberOfDays: string;
}

export interface NotificationRulesResult {
    ruleId: number;
    ruleName: string;
    event: string;
    userFk: number;
    protocolFk: number;
    protocolCode: string;
    effectiveDate: string;
    expirationDate: string;
    notificationMethod: boolean;
    frequency: string;
    isExpired: boolean;
}